import { StandardAction } from './standard-action';

export class SliderAction extends StandardAction {
  public min: number;
  public max: number;
  public step: number;
  public override value: number;
  public isOpen: boolean;

  public showLegend = false;
  public nbToDisplay = 0;
  public storageKey = '';

  // Rendre le constructeur privé
  private constructor(
    name: string,
    icon: string,
    min: number,
    max: number,
    step: number,
    value?: number,
    text?: string,
    tooltip?: string,
  ) {
    super(name, icon, text, tooltip);
    this.min = min;
    this.max = max;
    this.step = step;
    this.value = value !== undefined ? value : min;
    this.category = 'slider';
  }

  // Méthode statique pour permettre au builder d'instancier SliderAction
  public static create(
    name: string,
    icon: string,
    min: number,
    max: number,
    step = 1,
    value?: number,
    text?: string,
    tooltip?: string,
  ): SliderAction {
    return new SliderAction(name, icon, min, max, step, value, text, tooltip);
  }
}
